import * as React from "react";
import { createRoot } from "react-dom/client";
import PensionAgeCalculator from "./Components/PensionAgeCalculator";

(() => {
    const root = document.getElementsByClassName("pension-calculator-root")[0];

    if (!root) {
        return;
    }
    const container = root.getElementsByClassName("pension-calculator-wrapper")[0];
    if (!container) {
        console.error("Can't find pension calculator wrapper");
        return;
    }

    const firstYearWithData = Number(root.getAttribute("data-first-year-with-data"));
    const lastYearWithData = Number(root.getAttribute("data-last-year-with-data"));
    const sourceFileId = root.getAttribute("data-source-file-id");
    const estimationsStart = Number(root.getAttribute("data-estimations-start-year"));
    const estimationsLabel = root.getAttribute("data-estimations-label");
    const yearInputPlaceholder = root.getAttribute("data-year-input-placeholder");
    const monthInputLabel = root.getAttribute("data-month-input-label");
    const monthsLabel = root.getAttribute("data-months-label");
    const yearsLabel = root.getAttribute("data-years-label");
    const lowestLabel = root.getAttribute("data-lowest-age-label");
    const targetLabel = root.getAttribute("data-target-age-label");
    const latestLabel = root.getAttribute("data-latest-age-label");
    const dateLabel = root.getAttribute("data-date-label");

    if (isNaN(firstYearWithData)
        || isNaN(lastYearWithData)) {
        console.error("Can't parse start and end year");
        return;
    }

    createRoot(container).render(
        <PensionAgeCalculator
            firstBirthYearWithData={firstYearWithData}
            lastBirthYearWithData={lastYearWithData}
            sourceFileId={sourceFileId}
            estimationStartFrom={estimationsStart}
            estimationsLabel={estimationsLabel}
            yearInputPlaceholder={yearInputPlaceholder}
            monthInputLabel={monthInputLabel}
            monthsLabel={monthsLabel}
            yearsLabel={yearsLabel}
            lowestAgeLabel={lowestLabel}
            targetAgeLabel={targetLabel}
            latestAgeLabel={latestLabel}
            dateLabel={dateLabel}
        />
    );
})();
